import React, { useCallback, useState } from 'react';
import type { ActivityType, ActivityFeedFilters } from 'shared/src/api/activity-feed-api-types';
import { ActivityFilterBar } from '@/features/activity/ActivityFilterBar';
import { ActivityFeed } from '@/features/activity/ActivityFeed';

const AVAILABLE_ACTIVITY_TYPES: ActivityType[] = [
  'strategy_change',
  'line_item_change',
  'campaign_change',
  'zoho_note',
  'creative_request',
  'platform_entity_change',
  'rate_card_change'
];

const EMPTY_FILTERS: ActivityFeedFilters = {};

export function ActivityPage() {
  const [filters, setFilters] = useState<ActivityFeedFilters>(EMPTY_FILTERS);
  const [sortDirection, setSortDirection] = useState<'asc' | 'desc'>('desc');

  const handleClearFilters = useCallback(() => {
    setFilters(EMPTY_FILTERS);
  }, []);

  return (
    <div className="flex h-full flex-col overflow-hidden">
      <div className="shrink-0 border-b border-gray-200 bg-white px-6 py-4">
        <h1 className="mb-3 text-xl font-semibold text-gray-900">Activity</h1>
        <ActivityFilterBar
          availableActivityTypes={AVAILABLE_ACTIVITY_TYPES}
          filters={filters}
          onFilterChange={setFilters}
          sortDirection={sortDirection}
          onSortDirectionChange={setSortDirection}
          onClearFilters={handleClearFilters}
        />
      </div>
      <div className="min-h-0 flex-1 overflow-y-auto px-6 py-4">
        <ActivityFeed filters={filters} sortDirection={sortDirection} showCampaignName={true} />
      </div>
    </div>
  );
}
